import type { MutableRefObject } from "react";

/** Returns a check that stays true until the page switches to another project. */
export const watchProjectSwitch = (projectEpochRef: MutableRefObject<number>) => {
  const epoch = projectEpochRef.current;
  return () => projectEpochRef.current === epoch;
};
